import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_INVESTMENT_PROJECTS = 'ppis/investments/projects';

export default class PPIInvestmentProjectService extends SfpBaseService {

  static createPPIInvestmentProject(ppi_investment_project) {
		ppi_investment_project["visible"] = true
    const body = JSON.stringify({ppi_investment_project});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/${PPI_INVESTMENT_PROJECTS}`, {body, headers, method: "POST"})
      .then(super.returnResponse);
  }

  static updatePPIInvestmentProject(ppi_investment_project_id, ppi_investment_project) {
    const body = JSON.stringify({ppi_investment_project});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_investment_project_id}/investment/project`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

  static deletePPIInvestmentProject(ppi_investment_project_id) {
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_investment_project_id}/investment/project`, {headers, method: "DELETE"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-investment-project-service.js